import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#002ea7',
    secondary: '#0074c6',
    accent: '#8c9eff',
    error: '#da291c',
    warning: '#ff8200',
    info: '#00a3ad',
    success: '#97d700',
    cta: '#da291c'
  },
  iconfont: 'md'
});

Vue.config.productionTip = false

let sicherApp = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

